import { memo } from 'react';
import { Typography } from '@mui/material';
import { IconChartArcs, IconFile3d, IconFileZip, IconMap2 } from '@tabler/icons';
import NavGroup from './NavGroup';

const MenuList = () => {
	const menu_items = [
		{
			id: 'dashboard',
			title: 'Dashboard',
			type: 'group',
			children: [
				{
					id: 'dashboard_page',
					title: 'Dashboard',
					type: 'item',
					url: '/dashboard',
					icon: IconChartArcs,
				},
				{
					id: 'backup',
					title: 'Backup',
					type: 'item',
					url: '/dashboard/backup',
					icon: IconFileZip,
				},
			],
		},
		{
			id: 'amhc',
			title: 'AMHC',
			type: 'group',
			children: [
				{
					id: 'amhc_config',
					title: 'Configuration',
					type: 'item',
					url: '/dashboard/amhc',
					icon: IconMap2,
				},
				{
					id: 'caf_file_manager',
					title: 'File Manager',
					type: 'item',
					url: '/dashboard/amhc/file_manager',
					icon: IconFile3d,
				},
			],
		},
	];

	const nav_items = menu_items.map((item) => {
		switch (item.type) {
			case 'group':
				return <NavGroup key={item.id} item={item} />;
			default:
				return (
					<Typography key={item.id} variant="h6" color="error" align="center">
						Menu Items Error
					</Typography>
				);
		}
	});

	return <>{nav_items}</>;
};

export default memo(MenuList);
